import { useState, useEffect } from 'react';

// Single global interval shared by all components
let globalTime = Date.now();
const listeners = new Set();
let intervalId = null;

const startGlobalTimer = () => {
  if (intervalId === null) {
    intervalId = setInterval(() => {
      globalTime = Date.now();
      listeners.forEach((listener) => listener(globalTime));
    }, 1000);
  }
};

const stopGlobalTimer = () => {
  if (intervalId !== null && listeners.size === 0) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

// Hook that subscribes to the global timer
export default function useGlobalTimer() {
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    // Add this component to listeners
    listeners.add(setCurrentTime);

    // Start global timer if not running
    startGlobalTimer();

    // Cleanup: remove listener and stop timer if no more listeners
    return () => {
      listeners.delete(setCurrentTime);
      stopGlobalTimer();
    };
  }, []);

  return currentTime;
}
